export default __webpack_public_path__ + "static/medication-header-image-7cbe6cd67c69bea9a5f980988f6a8e30.webp";